export const gtmScript =
  '!function(e,t,a,n,g){e[n]=e[n]||[],e[n].push({"gtm.start":(new Date).getTime(),event:"gtm.js"});var m=t.getElementsByTagName(a)[0],r=t.createElement(a);r.async=!0,r.src="https://www.googletagmanager.com/gtm.js?id=GTM-KFNQ5FG",m.parentNode.insertBefore(r,m)}(window,document,"script","dataLayer");'

export const gtmNoScript =
  '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KFNQ5FG" height="0" width="0" style="display:none;visibility:hidden"></iframe>'
